// eslint-disable-next-line no-restricted-imports
import { Text as ReactNativeText, TextProps } from 'react-native';
import React, { forwardRef } from 'react';
import { isPatientApp } from '@/config/constants';
import { Text as AppText } from '@/components/ui/therapist/Text';

interface CustomTextProps extends TextProps {
  isResponsiveText?: boolean;
}

/**
 * Prevents override of font size by OS
 */
(ReactNativeText as any).defaultProps =
  (ReactNativeText as any)?.defaultProps || {};
(ReactNativeText as any).defaultProps.allowFontScaling = false;

/**
 * Prevents override of the fontweight
 * e.g. by android accessibility settings
 */
export const Text = forwardRef<ReactNativeText, CustomTextProps>(
  ({ children, className, isResponsiveText, ...textProps }, ref) => {
    return (
      <>
        {isPatientApp || isResponsiveText ? (
          <ReactNativeText
            ref={ref}
            className={`
              font-normal
              text-black
            `}
            {...textProps}
          >
            {children}
          </ReactNativeText>
        ) : (
          <AppText
            className={className}
            style={textProps.style}
            {...textProps}
            onPress={textProps.onPress}
            ref={ref}
          >
            {children}
          </AppText>
        )}
      </>
    );
  },
);

Text.displayName = 'Text';
